export class ResponseEmpty {}
